import { gql } from "@apollo/client";

// Components
import Head from "next/head";
import Header from "@/components-layout/header/header";
import Footer from "@/components-layout/footer/footer";
import Container from "@/components-layout/container/container";
import AbaIcon from "@/components/aba-icon/aba-icon";
import ScrollBtn from "@/components/scroll-btn/scroll-btn";

// Constants
import { genSetVars } from "@/constants/gql-fields";

// Style
import accStyle from "@/modules/accordion/accordion.module.scss";
import style from "@/styles/archive-faq.module.scss";

function handleClick(e) {
  const item = e.currentTarget;
  const parent = item.parentElement;
  const content = item.nextSibling;
  const isOpen = parent.attributes?.["data-open"]?.value;
  const toggle = isOpen === "false" ? true : false;

  item.ariaExpanded = toggle;
  parent.setAttribute("data-open", toggle);
  toggle ? content.removeAttribute("inert") : content.setAttribute("inert", "");
}

export default function Component(props) {
  // Loading state for previews
  if (props.loading) {
    return <>Loading...</>;
  }

  // Variables
  const data = props.data;
  // const siteTitle = data.generalSettings.title;
  // const title = data.page.title;
  let open = false;

  const faqCategories = data.faqCategories?.nodes;
  if (faqCategories)
    return (
      <>
        <Head>
          {/* <title>{`${title} - ${siteTitle}`}</title> */}
          <title>{data.page.seo.title}</title>
          <meta name="description" content={data.page.seo.metaDesc} />
        </Head>

        <Header entry={data.generalSettingsOptionsPage.generalSettingsACF} />

        <main className="archiveFaqs">
          <section>
            <Container>
              <div id="faq-hero">
                <h1>{data.page.title}</h1>
                <div dangerouslySetInnerHTML={{ __html: data.page.content }} />
              </div>
              <div className="posts">
                {data.faqCategories &&
                  data.faqCategories.nodes.map((faqCat) => {
                    if (
                      faqCat.faqs === null ||
                      faqCat.faqs.nodes?.length === 0
                    ) {
                      return;
                    }
                    return (
                      <div
                        id={faqCat.slug}
                        className={style.accordionItems}
                        key={faqCat.id}
                      >
                        <h2 className={style.faqCatTitle}>{faqCat.name}</h2>

                        {faqCat.faqs.nodes.map((faq, i) => {
                          return (
                            <div
                              className={accStyle.accordionItem}
                              data-open={open ? "true" : "false"}
                              key={i}
                            >
                              <button
                                // id={labelID}
                                className={accStyle.label}
                                aria-expanded="false"
                                // aria-controls={contentID}
                                onClick={handleClick}
                              >
                                <h3>{faq.title}</h3>
                                <div
                                  className={accStyle.iconContainer}
                                  data-icon-type={data.iconType}
                                >
                                  <AbaIcon name={AbaIcon.LIST.chevDown} />
                                </div>
                              </button>
                              <div
                                // id={contentID}
                                className={accStyle.content}
                                // aria-labelledby={labelID}
                                // {...(numItems > 6 && { role: "region" })}
                                {...(!open && { inert: true })}
                                dangerouslySetInnerHTML={{
                                  __html: faq.content,
                                }}
                              />
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
              </div>
            </Container>
          </section>

          <ScrollBtn />
        </main>

        <Footer entry={data.generalSettingsOptionsPage.generalSettingsACF} />
      </>
    );
}

Component.variables = (seedQuery, ctx) => {
  return {
    uri: seedQuery.uri,
  };
};

Component.query = gql`
  query GetArchive($uri: ID!) {
    # -- Site Settings
    # generalSettings {
    #   title
    # }
    
    page(id: 1878, idType: DATABASE_ID) {
    # page(id: $uri, idType: URI) {
      title
      content
      seo {
        metaDesc
        # fullHead
        title
      }
    }

    faqCategories(where: {orderby: TERM_ORDER, order: ASC}) {
      nodes {
        id
        name
        slug
        faqs(first:100, where: {orderby: {field: MENU_ORDER, order: ASC}} ) {
          __typename
          nodes {
            uri
            id
            title
            content
          }
        }
      }
    }

    # -- Header
    ...HeaderFragment @unmask(mode: "migrate")

    # -- Footer Fragment
    ...FooterFragment @unmask(mode: "migrate")

    # -- General Settings Variables
    ${genSetVars}
  }
  ${Header.fragments.entry}
  ${Footer.fragments.entry}
`;
